(function () {
  if (window.KleoProductAccordion) return;
  function setOpen(item, open) {
    const button = item.querySelector('.pdp-collapsible-trigger');
    const content = item.querySelector('.pdp-collapsible-content');
    if (!button || !content) return;
    item.classList.toggle('open', open);
    button.setAttribute('aria-expanded', String(open));
    content.setAttribute('aria-hidden', String(!open));
    content.inert = !open;
    const icon = button.querySelector('.pdp-collapsible-icon');
    if (icon) icon.textContent = open ? '–' : '+';
    if (!open) content.querySelectorAll('video').forEach(video => video.pause());
  }
  // Delegation also handles blocks Shopify replaces without a page reload.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.pdp-collapsible-trigger');
    if (!button) return;
    const item = button.closest('.pdp-collapsible-item');
    if (item) setOpen(item, !item.classList.contains('open'));
  });
  document.addEventListener('shopify:block:select', function (event) {
    const item = event.target.closest('.pdp-collapsible-item') || event.target.querySelector('.pdp-collapsible-item');
    if (item) setOpen(item, true);
  });
  window.KleoProductAccordion = { setOpen };
})();
